
  $(function() {
    
    if($('#ProductCartItems').length > 0) {
      let cartItems = JSON.parse($('#ProductCartItems').html());
      
  	  cartSort._init(cartItems);
    }
    
  })
  
  var cartSort = {
    
    cartItems: new Array(),
    cartItemsClone: new Array(),
    sortedCartItems: new Array(),
    sortedCartItemsIndex: 0,
    
    _init: function(cartItems) {
      	cartSort.cartItems = cartItems;
        cartSort.cartItemsClone = JSON.parse(JSON.stringify(cartSort.cartItems.items));
      	cartSort.sortedCartItems = new Array();
      	cartSort.sortedCartItemsIndex = 0;
      
    	cartSort._groupItems(cartSort.cartItemsClone);
      
      	if(cartSort.sortedCartItems.length > 0) {
      		CreateCartItem._init();
        }
        else {
          	CreateCartItem._empty();
        }

      console.log("Sorted:", cartSort.sortedCartItems)
      $('.cart-title-total-number').html(cartSort.sortedCartItems.length)
  	},
    
    _groupItems: function(items) {
      	cartSort.sortedCartItems = window.helper._groupVariants(items);
      
      	return cartSort.sortedCartItems;
    }
    
  
  };


var CreateCartItem = {
  
    _init: function() {
      if(window.location.pathname == '/cart') {
      	CreateCartItem._createCartItems();
      }
      
      CreateCartItem._createSideBarCartItems();
    },
  	
	_createCartItems: function() {
      $(".custom-cart-items").html(''); //To clear out old items everytime this runs
      
      for(i = window.cartSort.sortedCartItems.length-1; i >= 0; i--) {
        let cartItem = window.cartSort.sortedCartItems[i];
       	let cartItemDom = $('#custom_cart_item_dom').clone();
        // let prescriptionDetais = CreateCartItem._showPrescriptionDetails(cartItem.variants);
        let cartItemProperties = {};
        
        cartItemDom.removeAttr('id');
        cartItemDom.show(); 
        cartItemDom.find('.custom-cart-item__product').attr('href', cartItem.url);
        cartItemDom.find('.custom-cart-item__title').html(cartItem.product_title);
        cartItemDom.find('.custom-cart-item__image').attr('src', cartItem.featured_image.url);

        //Price
        if(cartItem.compare_at_price != 0) {
          cartItemDom.find('.custom-cart-item__final-price-wrapper').hide();
          cartItemDom.find('.custom-cart-item__final-price > span').html(window.helper._convertMoney(cartItem.compare_at_price));
          cartItemDom.find('.custom-cart-item__final-sale-price > span').html(window.helper._convertMoney(cartItem.final_line_price));
        }
        else {
          cartItemDom.find('.custom-cart-item__final-sale-price-wrapper').hide();
          cartItemDom.find('.custom-cart-item__final-price').html(window.helper._convertMoney(cartItem.final_line_price));
        }

        if(cartItem.variants[0].selling_plan_allocation != undefined) {
          cartItemDom.find('.custom-cart-item__subscription-text').html(cartItem.variants[0].selling_plan_allocation.selling_plan.name);
        }
        else {
          cartItemDom.find('.custom-cart-item__subscription-text').hide();
        }
        
        cartItemDom.find('.custom-cart-item__remove').on('click', function(e) {
          e.preventDefault();
          CreateCartItem._removeCartItem($(this));
        });

        // if(prescriptionDetais) {
        //   cartItemDom.find('.custom-cart-item__prescription-details-wrapper').append(prescriptionDetais)
        // }
        // else {
        //   cartItemDom.find('.custom-cart-item__prescription-details-wrapper').hide();
        // }

        //Sunglasses Update
        if(cartItem.variants[0].properties != undefined && cartItem.variants[0].properties['Sunglasses'] != undefined) {
          cartItemDom.find('.custom-cart-item__sunglasses-details-wrapper').show();
          cartItemDom.find('.custom-cart-item__sunglasses-details').html(cartItem.variants[0].properties['Sunglasses']);
          cartItemDom.find('.custom-cart-item__sunglasses-img').attr('src', cartItem.variants[0].properties['sunglasses_image']);
        }
        else {
          cartItemDom.find('.custom-cart-item__sunglasses-details-wrapper').hide();
        } 
        
        // Prescription Popup
        if(cartItem.variants[0].properties != undefined && cartItem.variants[0].properties['Eye'] != undefined) {
          cartItemDom.find('.custom-cart-item__prescription-details-wrapper > a').on('click', function(e){ 
            e.preventDefault();
            CreateCartItem._showPrescriptionDetails(cartItem.variants);
          });
        }
        else {
          cartItemDom.find('.custom-cart-item__prescription-details-wrapper').hide();
        }
        
        for (y = 0; y < cartItem.variants.length; y++) {        	
          	let variant = cartItem.variants[y];
        	let cartItemQtyDom = $('#custom_cart_item_qty_dom').clone();
          	
          	cartItemQtyDom.removeAttr('id');
        	cartItemQtyDom.show(); 
          	cartItemQtyDom.addClass('custom-cart-item__qty-'+variant.variant_options[0].toLowerCase());
          	cartItemQtyDom.attr('data-cart-item-key', variant.key);
          	cartItemQtyDom.find('input').val(variant.quantity);
            cartItemQtyDom.find('.custom-cart-item__variant-title').html('Quantity '+ (variant.variant_options[0] != "Default Title" ? variant.variant_options[0] : '' ));

            //Sunglasses Update
            if(variant.properties != undefined && variant.properties['Sunglasses'] != undefined) {
              cartItemDom.find('.custom-cart-item__variant-qty').hide();
            }
            else {
              CreateCartItem._quantityPlusMinusBtn(cartItemQtyDom.find('.custom-cart-item__qty-input-plus'), cartItemQtyDom.find('.custom-cart-item__qty-input-minus'));
            } 
          
            cartItemQtyDom.find('input').on("change", debounce(function() {
              CreateCartItem._updateQuantity(variant.key, cartItemQtyDom.find('input').val());
            }, 250))
          
          	cartItemDom.find('.custom-cart-item__variant-qty').append(cartItemQtyDom);
          
          if(variant.variant_options[0].toLowerCase() == 'left') {
            cartItemProperties.left = variant.properties;
          }
          else if (variant.variant_options[0].toLowerCase() == 'right') {
            cartItemProperties.right = variant.properties;
          }
        }
        
        cartItemDom.appendTo(".custom-cart-items");
      }
    },
  
    _createSideBarCartItems: function() {
      $(".sidebar-cart-items-wrapper").html(''); //To clear out old items everytime this runs
      
      for(i = window.cartSort.sortedCartItems.length-1; i >= 0; i--) {
        let cartItem = window.cartSort.sortedCartItems[i];
       	let cartItemDom = $('#sidebar_cart_item_dom').clone();
        let qtyText = "QTY: "
        
        cartItemDom.removeAttr('id');
        cartItemDom.show(); 
        cartItemDom.find('.sidebar-cart-item__product').attr('href', cartItem.url);
        cartItemDom.find('.sidebar-cart-item__title').html(cartItem.product_title);
        cartItemDom.find('.sidebar-cart-item__image').attr('src', cartItem.featured_image.url);
        cartItemDom.find('.sidebar-cart-item__final-price').html(window.helper._convertMoney(cartItem.final_line_price));

        if(cartItem.variants[0].selling_plan_allocation != undefined) {
          cartItemDom.find('.sidebar-cart-item__subscription-text').html(cartItem.variants[0].selling_plan_allocation.selling_plan.name);
        }
        else {
          cartItemDom.find('.sidebar-cart-item__subscription-text').hide();
        }
        
        for (y = 0; y < cartItem.variants.length; y++) {        	
          	let variant = cartItem.variants[y];
            if((cartItem.variants.length-1) == y) {
              qtyText +=  (variant.variant_options[0] != "Default Title" ? variant.variant_options[0] : '' )+ ": " + variant.quantity;  
            }
            else {
              qtyText +=  (variant.variant_options[0] != "Default Title" ? variant.variant_options[0] : '' ) + ": " + variant.quantity + " | "
            }
        }
        cartItemDom.find('.sidebar-cart-item__qty-text').html(qtyText);
        
        cartItemDom.appendTo(".sidebar-cart-items-wrapper");
        $('.sidebar-cart-items-wrapper__active').show();
        $('.sidebar-cart-items-wrapper__inactive').hide();
      }
      
      CreateCartItem._updateTotalPrice(window.cartSort.cartItems);
      CreateCartItem._updateCartCountBubble(window.cartSort.cartItems);
    },
    
    _updateQuantity: function(id, value) {
        let formData = {
          'id': id,
          'quantity': value
        };
      	
      	//start loading
      	$('.loading-spinner-wrapper').fadeIn();

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        }).then(
          function(state) {
            CreateCartItem._updateCartItems(state);
            
            //hide loading
            $('.loading-spinner-wrapper').fadeOut();
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error)
          }.bind(this)
        );
    },
    
    _removeCartItem: function(ele) {
      	let forData = {updates: {}}
      
        //start loading
        $('.loading-spinner-wrapper').fadeIn();

        $.each(ele.closest('.custom-cart-item').find('.custom-cart-item__variant-qty > div'), function(i,d){
          forData.updates[$(d).attr('data-cart-item-key')] = 0;
        });
        
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(forData)
        })
        .then(response => {
          return response.json();
        }).then(
          function(state) {
            CreateCartItem._updateCartItems(state);
      
            //hide loading
            $('.loading-spinner-wrapper').fadeOut();

          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error)
          }.bind(this)
        );
    },
    
    _updateCartItems: function(state) {
      window.cartSort._init(state);
    },
  
    _updateTotalPrice: function(state) {
      $('.totals__subtotal-value > span, .cart-subtotal__price').html(window.helper._convertMoney(state.total_price));
    },
  
    _updateCartCountBubble: function(cart) {
      if($('.cart-count-bubble').length < 1) {
        let countBubble = $('<div class="cart-count-bubble"><span aria-hidden="true">2</span><span class="visually-hidden">2 items</span></div>');
        countBubble.find('span:first-child').html(cart.item_count);
        countBubble.find('span:last-child').html(cart.item_count+'items');
        $('.header__icon--cart').append(countBubble);
      }
      else {

        $('.cart-count-bubble').find('span:first-child').html(cart.item_count);
        $('.cart-count-bubble').find('span:last-child').html(cart.item_count+'items');
      }
    },
    
    _quantityPlusMinusBtn: function(plus, minus) {
      minus.click(function () {
        var $input = $(this).parent().find('input');
        var count = parseInt($input.val()) - 1;
        count = count < 0 ? 0 : count;
        $input.val(count);
        $input.change();
        return false;
      });
      plus.click(function () {
        var $input = $(this).parent().find('input');
        $input.val(parseInt($input.val()) + 1);
        $input.change();
        return false;
      });
    },
  
    _showPrescriptionDetails: function(products) {
        for (p = 0; p < products.length; p++) {
          let optionProperties = $('<ul class="prescription-properties-list prescription-properties-list__'+products[p].variant_options[0].toLowerCase()+'">'+
                                     '<li class="prescription-properties-lsit-item-title">'+products[p].variant_options[0]+' Eye</li>'+
                                      '<li class="prescription-properties-lsit-item power">'+products[p].properties.Power+'</li>'+
                                      '<li class="prescription-properties-lsit-item power">'+products[p].properties["Base Curve"]+'</li>'+
                                      '<li class="prescription-properties-lsit-item power">'+products[p].properties.Diameter+'</li>'+
                                   '<li class="prescription-properties-lsit-item power">'+products[p].properties["Add Power"]+'</li>'+
                                  '</ul>');
          
          if(products[p].properties["Add Power"] == undefined) {
            $('.prescription-properties-list__option-labels li:nth-child(4)').hide();
            optionProperties.find('li:nth-child(5)').hide();
          }
          
          $('.prescription-info__product-title').html(products[p].product_title);
          optionProperties.appendTo('.prescription-info-grid');
        }
      	
      	window.prescriptionModal._show();
    },
  
    _empty: function() {
		//sidebar
        $('.sidebar-cart-items-wrapper__active').hide();
        $('.sidebar-cart-items-wrapper__inactive').show();
      
      	//cart
      	$('#main-cart-footer, .cart__contents').html(' ');
      	$('.cart__contents').hide();
        $('.cart__main-title-wrapper').hide();
      	$('.cart__warnings, .cart__empty-text').show();
    }
}



